import { combineReducers } from 'redux';
import employerExperienceApp from 'apps/employer-experience/state';
import memberExperienceApp from 'apps/member-experience/state';

export default combineReducers({
  'employer-experience': employerExperienceApp,
  memberExperience: memberExperienceApp,
});
